import styled from "styled-components";
import { Input } from "antd";
import { TEAL } from "../../EmployeeSkillsBridgerV2.constants";

// ─── Textarea ─────────────────────────────────────────────────────────────────

export const ReasonTextAreaStyled = styled(Input.TextArea)`
  resize: none;
`;

// ─── Antd Modal style config objects ─────────────────────────────────────────
// These are passed directly to antd Modal props, not CSS-in-JS.

export const REASON_MODAL_STYLES = {
  header: { paddingRight: 40 },
};

export const REASON_OK_BUTTON_PROPS = {
  style: { background: TEAL, borderColor: TEAL },
};
